<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S3Y0dQ/tc-custom/9781616281427.jpg?1705766094027" alt="This image is the cover for the book Ice Pops"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ice Pops
      </h1>
      <p class="bookDescription body article font2">
        <b>Make these cool creative pops—from fruity favorites to chocolate swirls to liquor-infused grownup desserts!</b><br/>  <br/> In these pages, you'll find over 40 recipes for frozen delights with tantalizing flavors—summer peach, bright watermelon and lime, rich chocolate swirled with vanilla or layered with raspberries, custard-based cheesecake and caramel, or green tea with pomegranate—which can be made either in an instant ice pop maker or conventional frozen pop molds.<br/>  <br/> From simple to inspired, discover an ice pop for any occasion, in this delicious book by a pastry chef and former <i>Martha Stewart Living</i> food editor.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shelly Kaldunski
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41ce8b0e